import React, {Component}   from 'react';
import PropTypes            from 'prop-types';

class ErrorApplicationSubmittedScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorTitle: 'Not found',
            errorMessage: null,
        };
    }

    componentWillMount() {
        if (this.props.params.type) {
            switch(this.props.params.type) {
                case 'no-auth':
                    this.setState({
                        errorTitle: 'Unauthorised access',
                        errorMessage: 'You were unsuccessful in authorising against our server.',
                    });
                    break;
                case 'no-application':
                    this.setState({
                        errorTitle: 'Cannot find application',
                        errorMessage: 'We were unable to find that application ID in our system.'
                    });
                    break;
                case 'cannot-submit-case':
                    this.setState({
                        errorTitle: 'Missing details to start referencing',
                        errorMessage: 'One or more vital pieces of information is missing in order for us to begin the referencing process.'
                    });
                    break;
                default:
                    this.setState({
                        errorTitle: 'Resource not found',
                        errorMessage: 'The page or resource you are trying to access cannot be found.'
                    });
                    break;
            }
        }
    }

    componentDidMount() {
        $('html, body').animate({
            scrollTop: $('body').offset().top - $('header.site-header').height()
        }, 500);
    }

    render() {
        return(
            <question-row class="header-row">
                <div className="question-top">
                    <h1>This application has been submitted</h1>
                    <p>To make changes and view the progress of your application, please visit the Referencing Portal.</p>
                    <p>You will have received an email with details of how access the Referencing Portal.</p>
                </div>
            </question-row>
        );
    }
}

ErrorApplicationSubmittedScreen.propTypes = {
    params: PropTypes.object,
};

export default ErrorApplicationSubmittedScreen;


// WEBPACK FOOTER //
// ./src/components/Screens/ErrorApplicationSubmittedScreen.js